module.exports = __webpack_public_path__ + "static/ebr-6-a8ca47ec5aef63654643f019ef8cf33f.jpg";